import { Route } from "@/types/routes"
import { defaultRedirectTo, defaultShouldRedirect } from "./shared"

export const ordersRoute: Route = {
  isPublic: false,
  shouldRedirect: (params) => params.isSupportRole ? false : defaultShouldRedirect(params),
  redirectTo: defaultRedirectTo,
}
